// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StartNew {
        height: 100%;

        display: flex;
        gap: 20px;

        padding: 20px;

        font-family: "Montserrat";

        overflow: hidden;
}

.SN_partition {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        flex-basis: 0;

        overflow: hidden;
}

.SN_requirementsLabel {
        font-size: 12px;
        font-weight: 500;
}

.SN_header {
        border: 1px solid #e4e4e4;
        background-color: #fff;
        border-bottom: none;

        height: 30px;
        display: flex;
        flex-shrink: 0;
        align-items: center;
        gap: 12.5px;

        border-top-left-radius: 8px;
        border-top-right-radius: 8px;

        font-size: 12px;
        font-weight: 600;

        padding: 0 12.5px;
}

.SN_header > *:nth-child(2) {
        padding-bottom: 1px;
        font-weight: 600;
        border-right: 1px solid #e4e4e4;
        height: 40%;
}

.SN_inputContainer {
        border: 1px solid #e4e4e4;

        display: flex;
        flex-grow: 1;

        background-color: #ffffff;

        overflow: hidden;

        position: relative;

        box-shadow:
                inset 0px -6px 5px -5px rgba(0, 0, 0, 0.027),
                inset 0px 0px 5px 2.5px rgba(0, 0, 0, 0.027)
        ;
}

.SN_requirementText {
        border: none;
        outline: none;
        resize: none;

        width: 100%;

        padding: 10px 12.5px;

        background-color: transparent;

        font-family: "Roboto";
        font-size: 12px;
        overflow-y: auto;
        border-radius: 5px;
}

#context.SN_requirementText {
        height: 15px;
}

.SN_inputContainer_uploadTypes > label > button.Button,
.SN_inputContainer > button.Button {
        height: 100%;
        border-radius: 0;
        padding: 0 15px;
        max-width: 45px;
        gap: 15px;
}

.SN_uploadIcon {
        height: 15px;
        margin: 10px 0 0 10px;
        cursor: pointer;
}

#SN_upload::file-selector-button {
        display: none;
}

.SN_files {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
}

.SN_buttonsFlex {
        display: flex;
        align-items: center;
        justify-content: space-between;

        margin: 20px 0;
}

.SN_runButtons {
        display: flex;
        justify-content: flex-end;
        gap: 10px;

        margin-top: 15px;
}

.SN_advancedSettings {
        display: flex;
        align-items: center;
        gap: 5px;

        cursor: pointer;

        margin-top: 30px;
}

.SN_advancedSettings_label {
        font-size: 10px;
}

.SN_advancedSettings_arrow {
        height: 5px;
}

.SN_advancedSettings_arrow.Show {
        transform: scaleY(-1);
}

.SN_advancedSettings_line {
        border: none;
        height: 1px;
        background: #e4e4e4;
        display: flex;
        flex-grow: 1;
}

.SN_toggleContainer {
        display: flex;
        align-items: center;
        width: -moz-fit-content;
        width: fit-content;
}

.SN_toggle {
        font-size: 10px;
        font-weight: bold;
}

.SN_toggle_switch {
        margin-left: 10px;

        border-radius: 15px;

        height: 12px;
        width: 23px;

        background-color: #b4b4b4;
        cursor: pointer;

        display: flex;
        align-items: center;

        padding: 0 2px;
}

.SN_toggle_switch.Show {
        background-color: #cc2500;
}

.SN_toggle_switch_circle {
        height: 8px;
        aspect-ratio: 1;
        border-radius: 50%;

        background-color: #ffffff;
}

.SN_toggle_switch_circle.Show {
        margin-left: 15px;
}

.SN_toggle_settingsIcon {
        margin-left: 8px;
        height: 18px;
}

.SN_toggle_downArrow {
        margin-left: 8px;
        height: 8px;
}

.SN_toggle_downArrow.up {
        transform: scaleY(-1);
}

.SN_HideContent {
        display: none;
}

.SN_ShowContent {
        border: 1px solid #e4e4e4;
        border-top: 0;

        padding: 15px;
}

.SN_dropdownsContainer {
        margin-top: 20px;

        display: flex;
        justify-content: space-between;

        gap: 15px;
}

.SN_dropdown {
        width: 150px;
        display: flex;
        flex-direction: column;
        gap: 5px;
}

.SN_dropdownLabel {
        font-size: 14px;
}

.SN_dropdown_border {
        border-radius: 6px;
        border: 1px solid #e4e4e4;
        height: 30px;
        box-sizing: border-box;
}

.SN_dropdownSelect {
        border-radius: 6px;
        height: 100%;
        width: 100%;

        border: none;
        outline: none;
        border-right: 10px solid transparent;

        padding: 0 10px;
        font-family: "Montserrat";
        font-weight: 500;
        font-size: 12px;

        cursor: pointer;

        box-sizing: border-box;
}

.SN_contextContainer {
        flex-grow: 1;
}

.SN_contextBorder {
        border-radius: 6px;
        overflow: hidden;
        height: 31px;
}

.SN_context {
        resize: none;

        font-family: "Montserrat";
        font-size: 12px;
        font-weight: 600;
        padding: 8px 15px;

        border: 1px solid #e4e4e4;
        border-radius: inherit;

        height: inherit;
        width: 100%;

        box-sizing: border-box;
}

.SN_tempLabelContainer {
        margin-top: 20px;
        display: flex;
        align-items: center;
}

#temp-tooltip {
        max-width: 400px;
}

.SN_tempSliderLabel {
        font-size: 14px;
        margin-top: 2px;
}

.SN_tempBarAndMarks {
        margin-left: 15px;
        flex-grow: 1;
}

.SN_tempSlider {
        margin-top: 0px;

        width: 100%;
        height: 5px;

        cursor: pointer;

        border: none;
        outline: none;
}

#SN_tempSlider_marks {
        display: flex;
        justify-content: space-between;
}

.SN_tempSlider_mark {
        font-family: 'Montserrat';
        font-size: 10px;
        padding: 0;
}

.SN_validationsLabel {
        margin-top: 20px;
        font-size: 14px;
}

.SN_validations {
        margin-top: 10px;
        border: 1px solid #e4e4e4;
        outline: none;

        height: 50px;
        width: 100%;
        resize: none;
        box-sizing: border-box;

        padding: 15px 20px;

        font-family: "Montserrat";
        font-size: 12px;
        font-weight: 600;
}

.SN_confirmContainer {
        margin-top: 20px;

        display: flex !important;
        flex-direction: column;
}

.SN_buttonsRow {
        display: flex;
        flex-direction: row;
        align-items: center;
}

.SN_priceContainer {
        display: flex;
        align-items: center;
        flex-grow: 1;
}

.SN_info {
        height: 14px;
        margin-left: 5px;
}

.SN_price {
        padding-top: 1px;
        font-size: 12px;
        font-weight: 600;
}

.SN_container_topRow {
        display: flex;
        align-items: center;
        justify-content: space-between;
}

.SN_right_hide {
        visibility: hidden;
}

.SN_right_header {
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
}

.SN_outputLabel {
        font-size: 13px;
        font-weight: bold;
}

.SN_exportOptionsContainer {
        position: absolute;
        z-index: 1;
        margin-top: -82px;
        border: 1px solid #e4e4e4;
        background-color: #fff;
        border-bottom: none;
        border-radius: 4px;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        width: 100%;

        box-shadow: 0 -1px 4px rgba(0, 0, 0, 0.05);
}

.SN_exportOption {
        font-family: "Montserrat";
        font-size: 12px;
        height: 25px;
        display: flex;
        align-items: center;
        padding: 0 10px;

        cursor: pointer;
}
.SN_exportOption:hover {
        background-color: #f3f3f3ec;
}
.SN_exportOption > img {
        height: 10px;
        margin-right: 5px;
}

.SN_historyDropdown {
        display: flex;
        flex-direction: column;

        border: 1px solid #e4e4e4;
        border-bottom: none;
        border-radius: 6px;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;

        height: 120px;
        width: 365px;

        position: absolute;
        z-index: 1;

        margin: -162px 0 0 242px;

        padding: 5px;

        box-shadow: 0 0 2px rgba(0, 0, 0, 0.1);
        background-color: #fff;
}

.SN_historyRecord {
        height: 40px;
        font-family: "Montserrat";
        font-size: 12px;

        display: flex;
        align-items: center;

        cursor: pointer;

        padding: 0 15px;

        border-radius: 4px;
}
.SN_historyRecord.selected {
        font-weight: 600;
}
.SN_historyRecord:hover {
        background-color: #f3f3f3ec;
}

.SN_historyRecord_index {
        display: flex;
        align-items: center;
        width: 25px;
}

.SN_historyRecord_fileName {
        padding: 10px 0;
        flex-grow: 1;
}

/* redundant parent needed for "sticky" absolute positioning of buttons */
.SN_outputBox {
        position: relative;

        display: flex;
        flex-direction: column;
        flex-grow: 1;

        overflow: hidden;
}

.SN_outputButtons {
        position: absolute;
        z-index: 1;

        top: 0;
        right: 0;

        width: 100%;

        display: flex;
        justify-content: flex-end;
        gap: 10px;

        padding: 8px 10px;

        /* make this raised div not obstruct onClick of lower div */
        pointer-events: none;
}

.SN_outputButtons > * {
        /* but ensure its buttons are clickable */
        pointer-events: all;
}

.SN_footer {
        border: 1px solid #e4e4e4;
        background-color: #fff;
        border-top: none;

        height: 30px;
        display: flex;
        flex-shrink: 0;

        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
        border-right: none;
}

.SN_footer.disable > button {
        opacity: 0.3;
        pointer-events: none;
}

#file-tooltip {
        z-index: 2;
}

.SN_footer_button {
        height: 100%;

        background-color: transparent;

        border: none;
        background-color: #fff;

        display: flex;
        flex-basis: 0;
        flex-grow: 1;
        align-items: center;
        justify-content: center;
        gap: 10px;

        cursor: pointer;

        position: relative;

        font-family: "Montserrat";
        font-size: 12px;

        padding: 0;
}

button.SN_footer_button {
        border-right: 1px solid #e4e4e4;
}

.SN_footer_button.disable {
        opacity: 0.3;
        pointer-events: none;
}

.SN_footer_button > label {
        cursor: pointer;
}

.SN_footer_button > img {
        height: 15px;
}

.SN_footer_button.left {
        max-width: 30px;

        border-bottom-left-radius: 8px;
}

.SN_footer_button.right {
        border-bottom-right-radius: 8px;
        border-right: none;
}

.SN_footer_button.update {
        border-right: none;
}

.SN_footer_button.generate {
        background-color: #4caf50;
}

.SN_footer_button.proceed {
        background-color: rgb(14, 187, 255);
}

.SN_footer_button.invert {
        color: #fff;
}

.SN_footer_button.invert > img {
        filter: brightness(0) invert(1);
}

.SN_outputContent {
        /* overflow-x: hidden; */
        overflow-y: auto;

        padding: 20px;
        padding-top: 0;
        text-align: justify;

        height: 100%;
        max-width: 100%;

        font-family: "Baskerville";

        /* also overrides textarea's default styles */
        border: 1px solid #e4e4e4;
        background: #fef9e1;

        box-shadow:
                inset 0px -6px 5px -5px rgba(0, 0, 0, 0.027),
                inset 0px 0px 5px 2.5px rgba(0, 0, 0, 0.027)
        ;
}

.SN_outputContent:focus { outline: none }
.SN_outputContent.edit {
        padding: 20px;

        font-family: "Roboto";
        font-size: 12px;

        resize: none;

        width: calc(100% - 40px);
}

.SN_outputContent > h1 {
        font-size: 22px;
        font-weight: 600;
}

.SN_outputContent > h2 {
        font-size: 20px;
        font-weight: 600;
}

.SN_outputContent > h3 {
        font-size: 18px;
        font-weight: 600;
}

.SN_outputContent > h4 {
        font-size: 16px;
        font-weight: 600;
}

.SN_outputContent > h5 {
        font-size: 14px;
        font-weight: 600;
}

.SN_outputContent > h6 {
        font-size: 12px;
        font-weight: 600;
}

.SN_outputContent > p,
.SN_outputContent > ol > li,
.SN_outputContent > ul > li {
        font-size: 12px;
}

.SN_advantagesContainer {
        border: 1px solid #e4e4e4;
        border-radius: 8px;
        padding: 15px;

        background-color: #fff;

        font-family: "Baskerville";
        font-size: 12px;

        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        height: 100%;

        gap: 20px;
}

.SN_advantages_header {
        font-size: 25px;
}

.SN_advantages_para {
        text-align: center;
}

.SN_advantages_para_bre {
        color: #cc2500;
}

.SN_advantagesList {
        display: flex;
        flex-direction: column;
        gap: 10px;

        width: 100%;
}

.SN_advantage {
        border: 1px solid #C02026;
        border-radius: 8px;
        height: 30px;

        display: flex;
        align-items: center;
        gap: 10px;

        padding: 10px;
}

.SN_advantage > img {
        height: 30px;
}

.SN_estimationsBox {
        margin-top: 20px;
        display: flex;
        flex-direction: column;
        height: 50%;
}

.SN_estimationsBox_content {
        margin-top: 10px;
        border: 1px solid #e4e4e4;
        border-radius: 8px;
        padding: 20px;
        overflow-y: auto;
}

/* .input_file_upload{
      flex: none;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
} */

.SN_explainableAI_icon {
        margin-left: auto;
        width: 15px;
        cursor: pointer;
        border-right: none !important;
}



.input_file_upload{
        display: flex;
        flex-direction: column;
        max-width: 100%;
        gap: 10px;
        overflow-y: auto;
}

.input_file_upload:has(div) {
        min-height: 100%;
        min-width: calc(100% - 40px);
        padding: 20px;
}
.input_file_upload > div {
        border: 1px solid #e4e4e4;
        padding: 5px 15px;
        font-size: 12px;
        height: -moz-fit-content;
        height: fit-content;

        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
}



.SN_requirementText::placeholder {
        opacity: 0.5; 
}
      .SN_submitButtonContainer {
        margin-top: 10px;
        display: flex;
        justify-content: flex-end; 
      }
      
      .SN_submitButton {
        padding: 2px 20px;
        background-color: #1f5f01; 
        border-radius: 4px;
        cursor: pointer;
        transition: background-color 0.3s ease;
        color:#ffffff;
        font-size: 10px;
      }
      
      .SN_submitButton:hover {
        background-color: #6c8660; 
      }

      ::-webkit-scrollbar {
        height: 3.5px;
        width: 4px;
      }

      ::-webkit-scrollbar-track {
        background: transparent;
      }
      

      ::-webkit-scrollbar-thumb {
        background: #00000041;
        border-radius: 5px;
        cursor: pointer;
      }
      
    
      ::-webkit-scrollbar-thumb:hover {
        background: #555;
      }
      .icons{
        height: 15px;
        margin-left: 8px;
      }`, "",{"version":3,"sources":["webpack://./src/screens/StartNew/StartNew.css"],"names":[],"mappings":"AAAA;QACQ,YAAY;;QAEZ,aAAa;QACb,SAAS;;QAET,aAAa;;QAEb,yBAAyB;;QAEzB,gBAAgB;AACxB;;AAEA;QACQ,aAAa;QACb,sBAAsB;QACtB,YAAY;QACZ,aAAa;;QAEb,gBAAgB;AACxB;;AAEA;QACQ,eAAe;QACf,gBAAgB;AACxB;;AAEA;QACQ,yBAAyB;QACzB,sBAAsB;QACtB,mBAAmB;;QAEnB,YAAY;QACZ,aAAa;QACb,cAAc;QACd,mBAAmB;QACnB,WAAW;;QAEX,2BAA2B;QAC3B,4BAA4B;;QAE5B,eAAe;QACf,gBAAgB;;QAEhB,iBAAiB;AACzB;;AAEA;QACQ,mBAAmB;QACnB,gBAAgB;QAChB,+BAA+B;QAC/B,WAAW;AACnB;;AAEA;QACQ,yBAAyB;;QAEzB,aAAa;QACb,YAAY;;QAEZ,yBAAyB;;QAEzB,gBAAgB;;QAEhB,kBAAkB;;QAElB;;;QAGA;AACR;;AAEA;QACQ,YAAY;QACZ,aAAa;QACb,YAAY;;QAEZ,WAAW;;QAEX,oBAAoB;;QAEpB,6BAA6B;;QAE7B,qBAAqB;QACrB,eAAe;QACf,gBAAgB;QAChB,kBAAkB;AAC1B;;AAEA;QACQ,YAAY;AACpB;;AAEA;;QAEQ,YAAY;QACZ,gBAAgB;QAChB,eAAe;QACf,eAAe;QACf,SAAS;AACjB;;AAEA;QACQ,YAAY;QACZ,qBAAqB;QACrB,eAAe;AACvB;;AAEA;QACQ,aAAa;AACrB;;AAEA;QACQ,aAAa;QACb,eAAe;QACf,WAAW;AACnB;;AAEA;QACQ,aAAa;QACb,mBAAmB;QACnB,8BAA8B;;QAE9B,cAAc;AACtB;;AAEA;QACQ,aAAa;QACb,yBAAyB;QACzB,SAAS;;QAET,gBAAgB;AACxB;;AAEA;QACQ,aAAa;QACb,mBAAmB;QACnB,QAAQ;;QAER,eAAe;;QAEf,gBAAgB;AACxB;;AAEA;QACQ,eAAe;AACvB;;AAEA;QACQ,WAAW;AACnB;;AAEA;QACQ,qBAAqB;AAC7B;;AAEA;QACQ,YAAY;QACZ,WAAW;QACX,mBAAmB;QACnB,aAAa;QACb,YAAY;AACpB;;AAEA;QACQ,aAAa;QACb,mBAAmB;QACnB,uBAAkB;QAAlB,kBAAkB;AAC1B;;AAEA;QACQ,eAAe;QACf,iBAAiB;AACzB;;AAEA;QACQ,iBAAiB;;QAEjB,mBAAmB;;QAEnB,YAAY;QACZ,WAAW;;QAEX,yBAAyB;QACzB,eAAe;;QAEf,aAAa;QACb,mBAAmB;;QAEnB,cAAc;AACtB;;AAEA;QACQ,yBAAyB;AACjC;;AAEA;QACQ,WAAW;QACX,eAAe;QACf,kBAAkB;;QAElB,yBAAyB;AACjC;;AAEA;QACQ,iBAAiB;AACzB;;AAEA;QACQ,gBAAgB;QAChB,YAAY;AACpB;;AAEA;QACQ,gBAAgB;QAChB,WAAW;AACnB;;AAEA;QACQ,qBAAqB;AAC7B;;AAEA;QACQ,aAAa;AACrB;;AAEA;QACQ,yBAAyB;QACzB,aAAa;;QAEb,aAAa;AACrB;;AAEA;QACQ,gBAAgB;;QAEhB,aAAa;QACb,8BAA8B;;QAE9B,SAAS;AACjB;;AAEA;QACQ,YAAY;QACZ,aAAa;QACb,sBAAsB;QACtB,QAAQ;AAChB;;AAEA;QACQ,eAAe;AACvB;;AAEA;QACQ,kBAAkB;QAClB,yBAAyB;QACzB,YAAY;QACZ,sBAAsB;AAC9B;;AAEA;QACQ,kBAAkB;QAClB,YAAY;QACZ,WAAW;;QAEX,YAAY;QACZ,aAAa;QACb,oCAAoC;;QAEpC,eAAe;QACf,yBAAyB;QACzB,gBAAgB;QAChB,eAAe;;QAEf,eAAe;;QAEf,sBAAsB;AAC9B;;AAEA;QACQ,YAAY;AACpB;;AAEA;QACQ,kBAAkB;QAClB,gBAAgB;QAChB,YAAY;AACpB;;AAEA;QACQ,YAAY;;QAEZ,yBAAyB;QACzB,eAAe;QACf,gBAAgB;QAChB,iBAAiB;;QAEjB,yBAAyB;QACzB,sBAAsB;;QAEtB,eAAe;QACf,WAAW;;QAEX,sBAAsB;AAC9B;;AAEA;QACQ,gBAAgB;QAChB,aAAa;QACb,mBAAmB;AAC3B;;AAEA;QACQ,gBAAgB;AACxB;;AAEA;QACQ,eAAe;QACf,eAAe;AACvB;;AAEA;QACQ,iBAAiB;QACjB,YAAY;AACpB;;AAEA;QACQ,eAAe;;QAEf,WAAW;QACX,WAAW;;QAEX,eAAe;;QAEf,YAAY;QACZ,aAAa;AACrB;;AAEA;QACQ,aAAa;QACb,8BAA8B;AACtC;;AAEA;QACQ,yBAAyB;QACzB,eAAe;QACf,UAAU;AAClB;;AAEA;QACQ,gBAAgB;QAChB,eAAe;AACvB;;AAEA;QACQ,gBAAgB;QAChB,yBAAyB;QACzB,aAAa;;QAEb,YAAY;QACZ,WAAW;QACX,YAAY;QACZ,sBAAsB;;QAEtB,kBAAkB;;QAElB,yBAAyB;QACzB,eAAe;QACf,gBAAgB;AACxB;;AAEA;QACQ,gBAAgB;;QAEhB,wBAAwB;QACxB,sBAAsB;AAC9B;;AAEA;QACQ,aAAa;QACb,mBAAmB;QACnB,mBAAmB;AAC3B;;AAEA;QACQ,aAAa;QACb,mBAAmB;QACnB,YAAY;AACpB;;AAEA;QACQ,YAAY;QACZ,gBAAgB;AACxB;;AAEA;QACQ,gBAAgB;QAChB,eAAe;QACf,gBAAgB;AACxB;;AAEA;QACQ,aAAa;QACb,mBAAmB;QACnB,8BAA8B;AACtC;;AAEA;QACQ,kBAAkB;AAC1B;;AAEA;QACQ,aAAa;QACb,qBAAqB;QACrB,8BAA8B;AACtC;;AAEA;QACQ,eAAe;QACf,iBAAiB;AACzB;;AAEA;QACQ,kBAAkB;QAClB,UAAU;QACV,iBAAiB;QACjB,yBAAyB;QACzB,sBAAsB;QACtB,mBAAmB;QACnB,kBAAkB;QAClB,4BAA4B;QAC5B,6BAA6B;QAC7B,WAAW;;QAEX,0CAA0C;AAClD;;AAEA;QACQ,yBAAyB;QACzB,eAAe;QACf,YAAY;QACZ,aAAa;QACb,mBAAmB;QACnB,eAAe;;QAEf,eAAe;AACvB;AACA;QACQ,2BAA2B;AACnC;AACA;QACQ,YAAY;QACZ,iBAAiB;AACzB;;AAEA;QACQ,aAAa;QACb,sBAAsB;;QAEtB,yBAAyB;QACzB,mBAAmB;QACnB,kBAAkB;QAClB,4BAA4B;QAC5B,6BAA6B;;QAE7B,aAAa;QACb,YAAY;;QAEZ,kBAAkB;QAClB,UAAU;;QAEV,wBAAwB;;QAExB,YAAY;;QAEZ,sCAAsC;QACtC,sBAAsB;AAC9B;;AAEA;QACQ,YAAY;QACZ,yBAAyB;QACzB,eAAe;;QAEf,aAAa;QACb,mBAAmB;;QAEnB,eAAe;;QAEf,eAAe;;QAEf,kBAAkB;AAC1B;AACA;QACQ,gBAAgB;AACxB;AACA;QACQ,2BAA2B;AACnC;;AAEA;QACQ,aAAa;QACb,mBAAmB;QACnB,WAAW;AACnB;;AAEA;QACQ,eAAe;QACf,YAAY;AACpB;;AAEA,yEAAyE;AACzE;QACQ,kBAAkB;;QAElB,aAAa;QACb,sBAAsB;QACtB,YAAY;;QAEZ,gBAAgB;AACxB;;AAEA;QACQ,kBAAkB;QAClB,UAAU;;QAEV,MAAM;QACN,QAAQ;;QAER,WAAW;;QAEX,aAAa;QACb,yBAAyB;QACzB,SAAS;;QAET,iBAAiB;;QAEjB,2DAA2D;QAC3D,oBAAoB;AAC5B;;AAEA;QACQ,yCAAyC;QACzC,mBAAmB;AAC3B;;AAEA;QACQ,yBAAyB;QACzB,sBAAsB;QACtB,gBAAgB;;QAEhB,YAAY;QACZ,aAAa;QACb,cAAc;;QAEd,8BAA8B;QAC9B,+BAA+B;QAC/B,kBAAkB;AAC1B;;AAEA;QACQ,YAAY;QACZ,oBAAoB;AAC5B;;AAEA;QACQ,UAAU;AAClB;;AAEA;QACQ,YAAY;;QAEZ,6BAA6B;;QAE7B,YAAY;QACZ,sBAAsB;;QAEtB,aAAa;QACb,aAAa;QACb,YAAY;QACZ,mBAAmB;QACnB,uBAAuB;QACvB,SAAS;;QAET,eAAe;;QAEf,kBAAkB;;QAElB,yBAAyB;QACzB,eAAe;;QAEf,UAAU;AAClB;;AAEA;QACQ,+BAA+B;AACvC;;AAEA;QACQ,YAAY;QACZ,oBAAoB;AAC5B;;AAEA;QACQ,eAAe;AACvB;;AAEA;QACQ,YAAY;AACpB;;AAEA;QACQ,eAAe;;QAEf,8BAA8B;AACtC;;AAEA;QACQ,+BAA+B;QAC/B,kBAAkB;AAC1B;;AAEA;QACQ,kBAAkB;AAC1B;;AAEA;QACQ,yBAAyB;AACjC;;AAEA;QACQ,mCAAmC;AAC3C;;AAEA;QACQ,WAAW;AACnB;;AAEA;QACQ,+BAA+B;AACvC;;AAEA;QACQ,wBAAwB;QACxB,gBAAgB;;QAEhB,aAAa;QACb,cAAc;QACd,mBAAmB;;QAEnB,YAAY;QACZ,eAAe;;QAEf,0BAA0B;;QAE1B,6CAA6C;QAC7C,yBAAyB;QACzB,mBAAmB;;QAEnB;;;QAGA;AACR;;AAEA,0BAA0B,cAAc;AACxC;QACQ,aAAa;;QAEb,qBAAqB;QACrB,eAAe;;QAEf,YAAY;;QAEZ,wBAAwB;AAChC;;AAEA;QACQ,eAAe;QACf,gBAAgB;AACxB;;AAEA;QACQ,eAAe;QACf,gBAAgB;AACxB;;AAEA;QACQ,eAAe;QACf,gBAAgB;AACxB;;AAEA;QACQ,eAAe;QACf,gBAAgB;AACxB;;AAEA;QACQ,eAAe;QACf,gBAAgB;AACxB;;AAEA;QACQ,eAAe;QACf,gBAAgB;AACxB;;AAEA;;;QAGQ,eAAe;AACvB;;AAEA;QACQ,yBAAyB;QACzB,kBAAkB;QAClB,aAAa;;QAEb,sBAAsB;;QAEtB,0BAA0B;QAC1B,eAAe;;QAEf,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,uBAAuB;;QAEvB,YAAY;;QAEZ,SAAS;AACjB;;AAEA;QACQ,eAAe;AACvB;;AAEA;QACQ,kBAAkB;AAC1B;;AAEA;QACQ,cAAc;AACtB;;AAEA;QACQ,aAAa;QACb,sBAAsB;QACtB,SAAS;;QAET,WAAW;AACnB;;AAEA;QACQ,yBAAyB;QACzB,kBAAkB;QAClB,YAAY;;QAEZ,aAAa;QACb,mBAAmB;QACnB,SAAS;;QAET,aAAa;AACrB;;AAEA;QACQ,YAAY;AACpB;;AAEA;QACQ,gBAAgB;QAChB,aAAa;QACb,sBAAsB;QACtB,WAAW;AACnB;;AAEA;QACQ,gBAAgB;QAChB,yBAAyB;QACzB,kBAAkB;QAClB,aAAa;QACb,gBAAgB;AACxB;;AAEA;;;;;;GAMG;;AAEH;QACQ,iBAAiB;QACjB,WAAW;QACX,eAAe;QACf,6BAA6B;AACrC;;;;AAIA;QACQ,aAAa;QACb,sBAAsB;QACtB,eAAe;QACf,SAAS;QACT,gBAAgB;AACxB;;AAEA;QACQ,gBAAgB;QAChB,4BAA4B;QAC5B,aAAa;AACrB;AACA;QACQ,yBAAyB;QACzB,iBAAiB;QACjB,eAAe;QACf,wBAAmB;QAAnB,mBAAmB;;QAEnB,gBAAgB;QAChB,mBAAmB;QACnB,uBAAuB;AAC/B;;;;AAIA;QACQ,YAAY;AACpB;MACM;QACE,gBAAgB;QAChB,aAAa;QACb,yBAAyB;MAC3B;;MAEA;QACE,iBAAiB;QACjB,yBAAyB;QACzB,kBAAkB;QAClB,eAAe;QACf,sCAAsC;QACtC,aAAa;QACb,eAAe;MACjB;;MAEA;QACE,yBAAyB;MAC3B;;MAEA;QACE,aAAa;QACb,UAAU;MACZ;;MAEA;QACE,uBAAuB;MACzB;;;MAGA;QACE,qBAAqB;QACrB,kBAAkB;QAClB,eAAe;MACjB;;;MAGA;QACE,gBAAgB;MAClB;MACA;QACE,YAAY;QACZ,gBAAgB;MAClB","sourcesContent":[".StartNew {\n        height: 100%;\n\n        display: flex;\n        gap: 20px;\n\n        padding: 20px;\n\n        font-family: \"Montserrat\";\n\n        overflow: hidden;\n}\n\n.SN_partition {\n        display: flex;\n        flex-direction: column;\n        flex-grow: 1;\n        flex-basis: 0;\n\n        overflow: hidden;\n}\n\n.SN_requirementsLabel {\n        font-size: 12px;\n        font-weight: 500;\n}\n\n.SN_header {\n        border: 1px solid #e4e4e4;\n        background-color: #fff;\n        border-bottom: none;\n\n        height: 30px;\n        display: flex;\n        flex-shrink: 0;\n        align-items: center;\n        gap: 12.5px;\n\n        border-top-left-radius: 8px;\n        border-top-right-radius: 8px;\n\n        font-size: 12px;\n        font-weight: 600;\n\n        padding: 0 12.5px;\n}\n\n.SN_header > *:nth-child(2) {\n        padding-bottom: 1px;\n        font-weight: 600;\n        border-right: 1px solid #e4e4e4;\n        height: 40%;\n}\n\n.SN_inputContainer {\n        border: 1px solid #e4e4e4;\n\n        display: flex;\n        flex-grow: 1;\n\n        background-color: #ffffff;\n\n        overflow: hidden;\n\n        position: relative;\n\n        box-shadow:\n                inset 0px -6px 5px -5px rgba(0, 0, 0, 0.027),\n                inset 0px 0px 5px 2.5px rgba(0, 0, 0, 0.027)\n        ;\n}\n\n.SN_requirementText {\n        border: none;\n        outline: none;\n        resize: none;\n\n        width: 100%;\n\n        padding: 10px 12.5px;\n\n        background-color: transparent;\n\n        font-family: \"Roboto\";\n        font-size: 12px;\n        overflow-y: auto;\n        border-radius: 5px;\n}\n\n#context.SN_requirementText {\n        height: 15px;\n}\n\n.SN_inputContainer_uploadTypes > label > button.Button,\n.SN_inputContainer > button.Button {\n        height: 100%;\n        border-radius: 0;\n        padding: 0 15px;\n        max-width: 45px;\n        gap: 15px;\n}\n\n.SN_uploadIcon {\n        height: 15px;\n        margin: 10px 0 0 10px;\n        cursor: pointer;\n}\n\n#SN_upload::file-selector-button {\n        display: none;\n}\n\n.SN_files {\n        display: flex;\n        flex-wrap: wrap;\n        width: 100%;\n}\n\n.SN_buttonsFlex {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n\n        margin: 20px 0;\n}\n\n.SN_runButtons {\n        display: flex;\n        justify-content: flex-end;\n        gap: 10px;\n\n        margin-top: 15px;\n}\n\n.SN_advancedSettings {\n        display: flex;\n        align-items: center;\n        gap: 5px;\n\n        cursor: pointer;\n\n        margin-top: 30px;\n}\n\n.SN_advancedSettings_label {\n        font-size: 10px;\n}\n\n.SN_advancedSettings_arrow {\n        height: 5px;\n}\n\n.SN_advancedSettings_arrow.Show {\n        transform: scaleY(-1);\n}\n\n.SN_advancedSettings_line {\n        border: none;\n        height: 1px;\n        background: #e4e4e4;\n        display: flex;\n        flex-grow: 1;\n}\n\n.SN_toggleContainer {\n        display: flex;\n        align-items: center;\n        width: fit-content;\n}\n\n.SN_toggle {\n        font-size: 10px;\n        font-weight: bold;\n}\n\n.SN_toggle_switch {\n        margin-left: 10px;\n\n        border-radius: 15px;\n\n        height: 12px;\n        width: 23px;\n\n        background-color: #b4b4b4;\n        cursor: pointer;\n\n        display: flex;\n        align-items: center;\n\n        padding: 0 2px;\n}\n\n.SN_toggle_switch.Show {\n        background-color: #cc2500;\n}\n\n.SN_toggle_switch_circle {\n        height: 8px;\n        aspect-ratio: 1;\n        border-radius: 50%;\n\n        background-color: #ffffff;\n}\n\n.SN_toggle_switch_circle.Show {\n        margin-left: 15px;\n}\n\n.SN_toggle_settingsIcon {\n        margin-left: 8px;\n        height: 18px;\n}\n\n.SN_toggle_downArrow {\n        margin-left: 8px;\n        height: 8px;\n}\n\n.SN_toggle_downArrow.up {\n        transform: scaleY(-1);\n}\n\n.SN_HideContent {\n        display: none;\n}\n\n.SN_ShowContent {\n        border: 1px solid #e4e4e4;\n        border-top: 0;\n\n        padding: 15px;\n}\n\n.SN_dropdownsContainer {\n        margin-top: 20px;\n\n        display: flex;\n        justify-content: space-between;\n\n        gap: 15px;\n}\n\n.SN_dropdown {\n        width: 150px;\n        display: flex;\n        flex-direction: column;\n        gap: 5px;\n}\n\n.SN_dropdownLabel {\n        font-size: 14px;\n}\n\n.SN_dropdown_border {\n        border-radius: 6px;\n        border: 1px solid #e4e4e4;\n        height: 30px;\n        box-sizing: border-box;\n}\n\n.SN_dropdownSelect {\n        border-radius: 6px;\n        height: 100%;\n        width: 100%;\n\n        border: none;\n        outline: none;\n        border-right: 10px solid transparent;\n\n        padding: 0 10px;\n        font-family: \"Montserrat\";\n        font-weight: 500;\n        font-size: 12px;\n\n        cursor: pointer;\n\n        box-sizing: border-box;\n}\n\n.SN_contextContainer {\n        flex-grow: 1;\n}\n\n.SN_contextBorder {\n        border-radius: 6px;\n        overflow: hidden;\n        height: 31px;\n}\n\n.SN_context {\n        resize: none;\n\n        font-family: \"Montserrat\";\n        font-size: 12px;\n        font-weight: 600;\n        padding: 8px 15px;\n\n        border: 1px solid #e4e4e4;\n        border-radius: inherit;\n\n        height: inherit;\n        width: 100%;\n\n        box-sizing: border-box;\n}\n\n.SN_tempLabelContainer {\n        margin-top: 20px;\n        display: flex;\n        align-items: center;\n}\n\n#temp-tooltip {\n        max-width: 400px;\n}\n\n.SN_tempSliderLabel {\n        font-size: 14px;\n        margin-top: 2px;\n}\n\n.SN_tempBarAndMarks {\n        margin-left: 15px;\n        flex-grow: 1;\n}\n\n.SN_tempSlider {\n        margin-top: 0px;\n\n        width: 100%;\n        height: 5px;\n\n        cursor: pointer;\n\n        border: none;\n        outline: none;\n}\n\n#SN_tempSlider_marks {\n        display: flex;\n        justify-content: space-between;\n}\n\n.SN_tempSlider_mark {\n        font-family: 'Montserrat';\n        font-size: 10px;\n        padding: 0;\n}\n\n.SN_validationsLabel {\n        margin-top: 20px;\n        font-size: 14px;\n}\n\n.SN_validations {\n        margin-top: 10px;\n        border: 1px solid #e4e4e4;\n        outline: none;\n\n        height: 50px;\n        width: 100%;\n        resize: none;\n        box-sizing: border-box;\n\n        padding: 15px 20px;\n\n        font-family: \"Montserrat\";\n        font-size: 12px;\n        font-weight: 600;\n}\n\n.SN_confirmContainer {\n        margin-top: 20px;\n\n        display: flex !important;\n        flex-direction: column;\n}\n\n.SN_buttonsRow {\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n}\n\n.SN_priceContainer {\n        display: flex;\n        align-items: center;\n        flex-grow: 1;\n}\n\n.SN_info {\n        height: 14px;\n        margin-left: 5px;\n}\n\n.SN_price {\n        padding-top: 1px;\n        font-size: 12px;\n        font-weight: 600;\n}\n\n.SN_container_topRow {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n}\n\n.SN_right_hide {\n        visibility: hidden;\n}\n\n.SN_right_header {\n        display: flex;\n        align-items: flex-end;\n        justify-content: space-between;\n}\n\n.SN_outputLabel {\n        font-size: 13px;\n        font-weight: bold;\n}\n\n.SN_exportOptionsContainer {\n        position: absolute;\n        z-index: 1;\n        margin-top: -82px;\n        border: 1px solid #e4e4e4;\n        background-color: #fff;\n        border-bottom: none;\n        border-radius: 4px;\n        border-bottom-left-radius: 0;\n        border-bottom-right-radius: 0;\n        width: 100%;\n\n        box-shadow: 0 -1px 4px rgba(0, 0, 0, 0.05);\n}\n\n.SN_exportOption {\n        font-family: \"Montserrat\";\n        font-size: 12px;\n        height: 25px;\n        display: flex;\n        align-items: center;\n        padding: 0 10px;\n\n        cursor: pointer;\n}\n.SN_exportOption:hover {\n        background-color: #f3f3f3ec;\n}\n.SN_exportOption > img {\n        height: 10px;\n        margin-right: 5px;\n}\n\n.SN_historyDropdown {\n        display: flex;\n        flex-direction: column;\n\n        border: 1px solid #e4e4e4;\n        border-bottom: none;\n        border-radius: 6px;\n        border-bottom-left-radius: 0;\n        border-bottom-right-radius: 0;\n\n        height: 120px;\n        width: 365px;\n\n        position: absolute;\n        z-index: 1;\n\n        margin: -162px 0 0 242px;\n\n        padding: 5px;\n\n        box-shadow: 0 0 2px rgba(0, 0, 0, 0.1);\n        background-color: #fff;\n}\n\n.SN_historyRecord {\n        height: 40px;\n        font-family: \"Montserrat\";\n        font-size: 12px;\n\n        display: flex;\n        align-items: center;\n\n        cursor: pointer;\n\n        padding: 0 15px;\n\n        border-radius: 4px;\n}\n.SN_historyRecord.selected {\n        font-weight: 600;\n}\n.SN_historyRecord:hover {\n        background-color: #f3f3f3ec;\n}\n\n.SN_historyRecord_index {\n        display: flex;\n        align-items: center;\n        width: 25px;\n}\n\n.SN_historyRecord_fileName {\n        padding: 10px 0;\n        flex-grow: 1;\n}\n\n/* redundant parent needed for \"sticky\" absolute positioning of buttons */\n.SN_outputBox {\n        position: relative;\n\n        display: flex;\n        flex-direction: column;\n        flex-grow: 1;\n\n        overflow: hidden;\n}\n\n.SN_outputButtons {\n        position: absolute;\n        z-index: 1;\n\n        top: 0;\n        right: 0;\n\n        width: 100%;\n\n        display: flex;\n        justify-content: flex-end;\n        gap: 10px;\n\n        padding: 8px 10px;\n\n        /* make this raised div not obstruct onClick of lower div */\n        pointer-events: none;\n}\n\n.SN_outputButtons > * {\n        /* but ensure its buttons are clickable */\n        pointer-events: all;\n}\n\n.SN_footer {\n        border: 1px solid #e4e4e4;\n        background-color: #fff;\n        border-top: none;\n\n        height: 30px;\n        display: flex;\n        flex-shrink: 0;\n\n        border-bottom-left-radius: 8px;\n        border-bottom-right-radius: 8px;\n        border-right: none;\n}\n\n.SN_footer.disable > button {\n        opacity: 0.3;\n        pointer-events: none;\n}\n\n#file-tooltip {\n        z-index: 2;\n}\n\n.SN_footer_button {\n        height: 100%;\n\n        background-color: transparent;\n\n        border: none;\n        background-color: #fff;\n\n        display: flex;\n        flex-basis: 0;\n        flex-grow: 1;\n        align-items: center;\n        justify-content: center;\n        gap: 10px;\n\n        cursor: pointer;\n\n        position: relative;\n\n        font-family: \"Montserrat\";\n        font-size: 12px;\n\n        padding: 0;\n}\n\nbutton.SN_footer_button {\n        border-right: 1px solid #e4e4e4;\n}\n\n.SN_footer_button.disable {\n        opacity: 0.3;\n        pointer-events: none;\n}\n\n.SN_footer_button > label {\n        cursor: pointer;\n}\n\n.SN_footer_button > img {\n        height: 15px;\n}\n\n.SN_footer_button.left {\n        max-width: 30px;\n\n        border-bottom-left-radius: 8px;\n}\n\n.SN_footer_button.right {\n        border-bottom-right-radius: 8px;\n        border-right: none;\n}\n\n.SN_footer_button.update {\n        border-right: none;\n}\n\n.SN_footer_button.generate {\n        background-color: #4caf50;\n}\n\n.SN_footer_button.proceed {\n        background-color: rgb(14, 187, 255);\n}\n\n.SN_footer_button.invert {\n        color: #fff;\n}\n\n.SN_footer_button.invert > img {\n        filter: brightness(0) invert(1);\n}\n\n.SN_outputContent {\n        /* overflow-x: hidden; */\n        overflow-y: auto;\n\n        padding: 20px;\n        padding-top: 0;\n        text-align: justify;\n\n        height: 100%;\n        max-width: 100%;\n\n        font-family: \"Baskerville\";\n\n        /* also overrides textarea's default styles */\n        border: 1px solid #e4e4e4;\n        background: #fef9e1;\n\n        box-shadow:\n                inset 0px -6px 5px -5px rgba(0, 0, 0, 0.027),\n                inset 0px 0px 5px 2.5px rgba(0, 0, 0, 0.027)\n        ;\n}\n\n.SN_outputContent:focus { outline: none }\n.SN_outputContent.edit {\n        padding: 20px;\n\n        font-family: \"Roboto\";\n        font-size: 12px;\n\n        resize: none;\n\n        width: calc(100% - 40px);\n}\n\n.SN_outputContent > h1 {\n        font-size: 22px;\n        font-weight: 600;\n}\n\n.SN_outputContent > h2 {\n        font-size: 20px;\n        font-weight: 600;\n}\n\n.SN_outputContent > h3 {\n        font-size: 18px;\n        font-weight: 600;\n}\n\n.SN_outputContent > h4 {\n        font-size: 16px;\n        font-weight: 600;\n}\n\n.SN_outputContent > h5 {\n        font-size: 14px;\n        font-weight: 600;\n}\n\n.SN_outputContent > h6 {\n        font-size: 12px;\n        font-weight: 600;\n}\n\n.SN_outputContent > p,\n.SN_outputContent > ol > li,\n.SN_outputContent > ul > li {\n        font-size: 12px;\n}\n\n.SN_advantagesContainer {\n        border: 1px solid #e4e4e4;\n        border-radius: 8px;\n        padding: 15px;\n\n        background-color: #fff;\n\n        font-family: \"Baskerville\";\n        font-size: 12px;\n\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n\n        height: 100%;\n\n        gap: 20px;\n}\n\n.SN_advantages_header {\n        font-size: 25px;\n}\n\n.SN_advantages_para {\n        text-align: center;\n}\n\n.SN_advantages_para_bre {\n        color: #cc2500;\n}\n\n.SN_advantagesList {\n        display: flex;\n        flex-direction: column;\n        gap: 10px;\n\n        width: 100%;\n}\n\n.SN_advantage {\n        border: 1px solid #C02026;\n        border-radius: 8px;\n        height: 30px;\n\n        display: flex;\n        align-items: center;\n        gap: 10px;\n\n        padding: 10px;\n}\n\n.SN_advantage > img {\n        height: 30px;\n}\n\n.SN_estimationsBox {\n        margin-top: 20px;\n        display: flex;\n        flex-direction: column;\n        height: 50%;\n}\n\n.SN_estimationsBox_content {\n        margin-top: 10px;\n        border: 1px solid #e4e4e4;\n        border-radius: 8px;\n        padding: 20px;\n        overflow-y: auto;\n}\n\n/* .input_file_upload{\n      flex: none;\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n      justify-content: center;\n} */\n\n.SN_explainableAI_icon {\n        margin-left: auto;\n        width: 15px;\n        cursor: pointer;\n        border-right: none !important;\n}\n\n\n\n.input_file_upload{\n        display: flex;\n        flex-direction: column;\n        max-width: 100%;\n        gap: 10px;\n        overflow-y: auto;\n}\n\n.input_file_upload:has(div) {\n        min-height: 100%;\n        min-width: calc(100% - 40px);\n        padding: 20px;\n}\n.input_file_upload > div {\n        border: 1px solid #e4e4e4;\n        padding: 5px 15px;\n        font-size: 12px;\n        height: fit-content;\n\n        overflow: hidden;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n}\n\n\n\n.SN_requirementText::placeholder {\n        opacity: 0.5; \n}\n      .SN_submitButtonContainer {\n        margin-top: 10px;\n        display: flex;\n        justify-content: flex-end; \n      }\n      \n      .SN_submitButton {\n        padding: 2px 20px;\n        background-color: #1f5f01; \n        border-radius: 4px;\n        cursor: pointer;\n        transition: background-color 0.3s ease;\n        color:#ffffff;\n        font-size: 10px;\n      }\n      \n      .SN_submitButton:hover {\n        background-color: #6c8660; \n      }\n\n      ::-webkit-scrollbar {\n        height: 3.5px;\n        width: 4px;\n      }\n\n      ::-webkit-scrollbar-track {\n        background: transparent;\n      }\n      \n\n      ::-webkit-scrollbar-thumb {\n        background: #00000041;\n        border-radius: 5px;\n        cursor: pointer;\n      }\n      \n    \n      ::-webkit-scrollbar-thumb:hover {\n        background: #555;\n      }\n      .icons{\n        height: 15px;\n        margin-left: 8px;\n      }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
